export default __webpack_public_path__ + "static/port4-2c717541eae983f44ef00ff6bb9f1390.jpg";